module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-06-19 at 12.53.28 PM.bcc9cdcf.jpg";